import React from 'react';

import cn from 'classnames';

import { Flex, UiText } from '@shared/ui';

import cls from './PositionDragPreview.module.css';
import { DraggableEl } from '../DraggableEl';

interface IPositionDragPreviewProps {
    name: string;
    className?: string;
}
export const PositionDragPreview = ({ name, className }: IPositionDragPreviewProps) => (
    <Flex className={cn(cls.PositionDragPreview, className)} gap={8}>
        <DraggableEl />
        <UiText variant="mediumPlain" tag="span">
            {name}
        </UiText>
    </Flex>
);
